import React from 'react';
import { Container } from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';

import PaywayPaymentForm from './payment/PaywayPaymentForm';

// Página de pago con Payway: /pagar/:purchaseOrderId?t=<token>.
//
// Se entra por link, sin sesión: el comprador puede venir del mail o de "Mis
// órdenes". El `?t=` es lo que autoriza — sin él la API responde 404. El
// formulario en sí vive en payment/PaywayPaymentForm, que también se monta en
// un diálogo sobre la videollamada (cart/InCallPayDialog).

const PaymentPage = () => {
    const { purchaseOrderId } = useParams();
    const [searchParams] = useSearchParams();
    const accessToken = searchParams.get('t');

    return (
        <Container maxWidth="sm" sx={{ py: 4 }}>
            <PaywayPaymentForm
                purchaseOrderId={purchaseOrderId}
                accessToken={accessToken}
            />
        </Container>
    );
};

export default PaymentPage;
